var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147_2886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2938 1.6499L7.64746 9.29624",
    stroke: "white",
    strokeWidth: 1.56402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2931 1.6499L10.4272 15.5523L7.64672 9.29624L1.39062 6.51576L15.2931 1.6499Z",
    stroke: "white",
    strokeWidth: 1.56402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_2886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6829,
    height: 16.6829,
    fill: "white",
    transform: "translate(0 0.259277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWhite);
export default __webpack_public_path__ + "static/media/send-white.65d266081a05db9c5f4ab8207d852d92.svg";
export { ForwardRef as ReactComponent };